module.exports = __webpack_public_path__ + "img/iii.a335c561.png";